import { AuthLayout } from '../components/AuthLayout';
import VerifyPhoneForm from './VerifyPhoneForm';

const VerifyPhone = () => (
  <AuthLayout>
    <VerifyPhoneForm />
  </AuthLayout>
);

export default VerifyPhone;
